import React, { useMemo } from 'react';

export interface VehicleSectionNavItem {
  id: string;
  label: string;
}

interface VehicleSectionNavProps {
  items: VehicleSectionNavItem[];
  className?: string;
}

/**
 * In-page section jump nav for the vehicle profile.
 * Sticky on all breakpoints: horizontal scroll chips on mobile, wrapped links on md+.
 */
export const VehicleSectionNav: React.FC<VehicleSectionNavProps> = ({ items, className = '' }) => {
  const visible = useMemo(() => items.filter((item) => item.id && item.label), [items]);
  if (visible.length < 2) return null;

  return (
    <nav
      aria-label="On this build"
      className={`sticky top-14 z-[35] -mx-4 sm:-mx-6 lg:-mx-8 px-4 sm:px-6 lg:px-8 py-2 bg-[#0a0a0a]/95 backdrop-blur-md border-b border-white/[0.06] ${className}`.trim()}
    >
      <ul className="flex gap-1 list-none max-w-7xl mx-auto overflow-x-auto overscroll-x-contain scrollbar-thin pb-0.5 md:flex-wrap md:overflow-visible">
        {visible.map((item) => (
          <li key={item.id} className="shrink-0 md:shrink">
            <a
              href={`#${item.id}`}
              className="inline-flex items-center min-h-[36px] px-3.5 py-1.5 text-xs font-medium tracking-wide text-gray-400 hover:text-white rounded-md hover:bg-white/[0.06] transition-colors duration-200 whitespace-nowrap focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange-500/50"
            >
              {item.label}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default VehicleSectionNav;
